module.exports = __webpack_public_path__ + "static/fonts/iconfont.de2dad57.woff2";